import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { label: "现场速递", href: "#feed" },
  { label: "影像图证", href: "#docs" },
  { label: "话题索引", href: "#index" },
  { label: "目击者说", href: "#witness" },
  { label: "正在热议", href: "#discuss" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      id="top"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || open ? "bg-background-50/95 backdrop-blur border-b border-foreground-200/70" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-6xl items-center justify-between px-4 md:px-6">
        {/* brand */}
        <a href="#top" className="flex items-center gap-2.5">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-[16px]" aria-hidden="true" />
          </span>
          <span className="leading-none">
            <span className="block font-serif text-xl md:text-2xl font-black tracking-tight text-foreground-950">
              911网
            </span>
            <span className="mt-1 block text-[10px] tracking-[0.28em] text-foreground-500 hidden md:block">
              现场资料聚合档案
            </span>
          </span>
        </a>

        {/* desktop nav */}
        <nav className="hidden md:flex items-center gap-8" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="group relative text-[15px] text-foreground-700 transition-colors hover:text-primary-600 whitespace-nowrap"
            >
              {item.label}
              <span className="absolute -bottom-1.5 left-0 h-0.5 w-0 bg-primary-500 transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        {/* actions */}
        <div className="flex items-center gap-3">
          <a
            href="#discuss"
            className="hidden md:inline-flex items-center gap-2 rounded-full border border-foreground-300/80 px-4 py-2 text-[13px] text-foreground-700 transition-colors hover:border-primary-500 hover:text-primary-600 whitespace-nowrap"
          >
            <i className="ri-flashlight-line text-[15px]" aria-hidden="true" />
            进入现场
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-foreground-200 md:hidden"
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={`ri-${open ? "close-line" : "menu-line"} text-xl`} aria-hidden="true" />
          </button>
        </div>
      </div>

      {/* mobile panel */}
      {open && (
        <nav className="md:hidden border-t border-foreground-200/70 bg-background-50 px-4 py-4" aria-label="移动端导航">
          <ul className="flex flex-col">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between border-b border-foreground-200/50 py-3.5 text-[15px] text-foreground-800 hover:text-primary-600"
                >
                  {item.label}
                  <i className="ri-arrow-right-up-line text-foreground-400" aria-hidden="true" />
                </a>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
}